<template>
  <div>
    <div class="text-left">
      <naj-button
        v-if="!isOrganizationUser"
        type="button"
        size="small"
        @click="validateThenSend"
      >
        <v-icon
          right
          v-text="`mdi-plus`"
        ></v-icon>
        {{ local.home.tabCommon.newReplyMemo }}
      </naj-button>
    </div>
    <v-row class="mx-12">
      <template>
        <v-col
          v-for="(replyMemo, index) in replyMemos"
          :key="index"
          cols="4"
        >
          <bankruptcy-card
            :info-item="replyMemo"
            :icon="'mdi-archive'"
            :header="`${local.bankruptcy.bankruptcyFile.replyMemos.cardHeader}`"
            :code-display-name="local.caseFile.cards.request.codeDisplayName"
            :code="replyMemo.code"
            :date="replyMemo.creationDate"
            :date-display-name="local.caseFile.cards.request.dateDisplayName"
            :has-actions="true"
            :court-name="replyMemo.courtName"
            :sub-circle-name="replyMemo.subCircleName"
          >
            <template
              slot="actions"
              slot-scope="{}"
            >
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-icon
                    large
                    v-on="on"
                  >
                    mdi-dots-vertical
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      <router-link :to="`/bankruptcy/${requestObjectKey}/reply-memo/${replyMemo.objectKey}`">
                        <naj-button
                          text
                          type="button"
                          size="small"
                        >
                          {{ local.bankruptcy.replyMemo.view }}
                        </naj-button>
                      </router-link>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </bankruptcy-card>
        </v-col>
      </template>
      <v-col cols="12">
        <naj-no-data
          :has-data="replyMemos && replyMemos.length > 0"
          :loading="loading"
        ></naj-no-data>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('BankruptcyModule');
import BankruptcyCard from '../bankruptcy-card.vue';
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
import { userType } from '@/helpers/enum';
import { Urls } from '@/modules/judicialFees/helpers/enum';

export default {
  name: 'ReplyMemosTab',
  components: { BankruptcyCard },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
    },
    requestInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      replyMemos: [],
      userType,
      Urls,
    };
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    isOrganizationUser() {
      return this.userInfo.userType == userType.najizOrganization;
    },
  },
  watch: {},
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(['getMainRequestReplyMemos', 'canIssueReplyMemo']),
    loadData() {
      this.loading = true;
      this.getMainRequestReplyMemos(this.requestObjectKey)
        .then((res) => {
          this.replyMemos = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    validateThenSend() {
      this.canIssueReplyMemo(this.requestObjectKey)
        .then(() => {
          this.$router.push({ path: `/bankruptcy/${this.requestObjectKey}/reply-memo` });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};

</script>
